import { X } from "lucide-react";
import React, { useState, type SetStateAction } from "react";

interface IProps {
  isOpen: boolean;
  header: string;
  setIsOpen: React.Dispatch<SetStateAction<boolean>>;
  children?: React.ReactNode;
  className?: string;
}

const Drawer: React.FC<IProps> = ({ isOpen, header, children, className, setIsOpen }) => {
  return (
    <>
      <div
        className={`w-screen h-screen absolute inset-0 z-[1000] bg-[#0000004D] -left-[120vw] duration-300 ease-in-out ${
          isOpen && "left-0"
        }`}
      />
      <div
        className={`sm:w-[450px] w-[350px] min-h-[450px] overflow-y-auto p-4 px-6 rounded-lg bg-white inset-0 absolute z-[1100] h-fit left-auto -right-[150vw] inset-y-0 my-auto duration-[400ms] flex flex-col gap-5 ease-in-out pb-4 ${
          isOpen && "!right-0 mx-auto !left-0"
        } ${className}`}
      >
        <div className="w-full flex flex-col gap-1">
          <div className="flex justify-between">
            <h1 className="text-gray-900 font-medium text-xl">{header}</h1>
            <button
              onClick={() => {
                setIsOpen(false);
              }}
              type="button"
            >
              <X className="text-gray-400 h-5 w-5" />
            </button>
          </div>
        </div>
        {children}
      </div>
    </>
  );
};

export default Drawer;
